<template>
    <div class="e6-pagination">
        <el-pagination
                @current-change="currentChange"
                @size-change="sizeChange"
                :current-page="currentPage"
                :page-sizes="pageSizes"
                :page-size="pageSize"
                :layout="layout"
                :total="total"
        >
        </el-pagination>
    </div>
</template>

<script>
    export default {
        name: "E6Pagination",
        props: {
            pageSizes: {
                type: Array,
                default: function () {
                    return [10, 20, 50, 100, 200];
                }
            },
            pageSize: {
                type: Number,
                default: 10
            },
            layout: {
                type: String,
                default: "total, sizes, prev, pager, next, jumper"
            },
            total: {
                type: Number,
                default: 0
            },
            currentPage: {
                type: Number,
                default: 1
            }
        },
        methods: {
            sizeChange(pageSize) {
                this.$emit("update:pageSize", pageSize);
                this.$emit("sizeChange", pageSize);
            },
            currentChange(currentPage) {
                this.$emit("update:currentPage", currentPage);
                this.$emit("currentChange", currentPage);
            }
        }
    };
</script>
